import _ from "lodash";
import update from "immutability-helper";

/*

 - you can use this HOF for loadMoreFeed fn which we use in pagination
 - variable: it will be your query variables 
 - queryData: here queryData will be object that return by graphql HOC in props({obj,ownProps}) eg. getProjectGroupSupervisors
 - nodeKey: default value is "node"
 - key: this will be your entity name like students,supervisors for ex if your query response is like this 
 - customPathString: can be used to go to deeper level to get edges
            node:{
              id:15,
              projects:{
                totalCount:100,
                edges:[...],
                pageInfo:{
                  hasNextPage:true,
                  "endCursor":"some string"
                }
              }

            }
      then your key will be "projects".

 see Example at: src/routes/routes/Teacher/routes/Projects/routes/Setup/routes/Invite/routes/Supervisors/components/SupervisorList/SupervisorList.js

*/

const prepareLoadMoreFeed = ({
  variables,
  queryData,
  key,
  nodeKey = "node",
  edgesKey = "edges",
  customPathString = "",
  isCursorUsingAfter = true,
}) => {
  return () => {
    return queryData.fetchMore({
      variables,
      updateQuery: (previousResult, { fetchMoreResult }) => {
        let nextItems, currentItems;
        if (customPathString) {
          nextItems = _.get(fetchMoreResult, customPathString, []);
          currentItems = _.get(previousResult, customPathString, []);
        } else nextItems = fetchMoreResult[nodeKey][key];

        const nextEdges = nextItems[edgesKey];

        const nextPageInfo = nextItems.pageInfo;

        const nextEndCursor = nextPageInfo.endCursor;
        const nextHasNextPage = nextPageInfo.hasNextPage;

        const nextStartCursor = nextPageInfo.startCursor;

        const updateObject = isCursorUsingAfter
          ? {
              [edgesKey]: { $push: nextEdges },
              pageInfo: {
                endCursor: { $set: nextEndCursor },
                hasNextPage: { $set: nextHasNextPage },
              },
            }
          : {
              [edgesKey]: { $unshift: nextEdges },
              pageInfo: {
                startCursor: { $set: nextStartCursor },
                hasPreviousPage: { $set: nextHasNextPage },
              },
            };

        if (customPathString) {
          const clonedPreviosResult = _.cloneDeep(previousResult);
          return _.set(
            clonedPreviosResult,
            customPathString,
            update(currentItems, updateObject)
          );
        }

        return update(previousResult, {
          [nodeKey]: {
            [key]: updateObject,
          },
        });
      },
    });
  };
};

export default prepareLoadMoreFeed;
